/*
  Смена стадии у выбранных в реестре счетов (16.10.2026).

  Тот же выбор, что в карточке счёта: стадия и причина, причина попадает в
  журнал действий у каждого счёта. Отказы приходят по счёту (например, «счёт уже
  в этой стадии») и не отменяют смену у остальных; что не сменилось и почему,
  страница показывает после закрытия окна.
*/

import { useState } from 'react'

import { api } from '../api/client.js'
import { STAGE_TITLES, accounts, accountsGenitive } from '../api/format.js'
import { Field, Notice } from './Common.jsx'
import Modal from './Modal.jsx'
import Dropdown from './Select.jsx'

export default function StageBulkDialog({ chosen, onClose, onChanged }) {
  const [stage, setStage] = useState('')
  const [reason, setReason] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)

  async function submit(event) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      onChanged(
        await api.changeStages(
          chosen.map((row) => row.account_id),
          stage,
          reason.trim(),
        ),
      )
    } catch (failure) {
      setError(failure)
      setBusy(false)
    }
  }

  return (
    <Modal title={`Сменить стадию: ${accounts(chosen.length)}`} onClose={onClose} busy={busy}>
      <form onSubmit={submit}>
        <div className="modal__text">
          <div className="row">
            <div className="field field--s">
              <span className="field__label" id="bulk-stage-label">
                Новая стадия
              </span>
              <Dropdown
                value={stage}
                onChange={setStage}
                options={STAGE_TITLES}
                empty="выберите"
                labelledBy="bulk-stage-label"
              />
            </div>
            <Field label="Причина - попадёт в журнал действий" width="m">
              <input
                className="field__input"
                value={reason}
                onChange={(event) => setReason(event.target.value)}
                minLength={3}
                required
              />
            </Field>
          </div>
        </div>
        <Notice error={error} />
        <div className="row row--tight">
          {/* Выключена, пока не выбрана стадия и не написана причина: свой
              выпадающий список браузер не проверяет (правило 6в скилла). */}
          <button
            type="submit"
            className="button"
            disabled={busy || !stage || reason.trim().length < 3}
          >
            Сменить у {accountsGenitive(chosen.length)}
          </button>
          <button type="button" className="button button--quiet" onClick={onClose} disabled={busy}>
            Отмена
          </button>
        </div>
      </form>
    </Modal>
  )
}
